import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorHandler,Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private router: Router) {}

  handleError(error: Error | HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
        if (error.status === HttpStatusCode.InternalServerError) {
            if (error.url?.includes('fundfamilydetail')) {
                this.router.navigate(
                  ['mutual-funds'],
                  { queryParamsHandling: 'merge' }
                  
                ).then(() => window.location.reload());
            }
        }
    }
      
    console.error(error);
  }
}